import ReportSwitchRawImagery from './ReportSwitchRawImagery';

export default ReportSwitchRawImagery;
